<template>
  <div class="blanco-page wrapper">
    <keep-alive>
      <component
        :is="dynamicComponent"
        :candidate="candidate"
        :blankModus="blankModus"
        @candidateUpdated="setNewCandidate($event)"
        @intakeNoteUpdated="setIntakeNote($event)"
        @switchPage="switchHandler"
        @unsavedChanges="hasUnsavedChanges($event)"
      ></component>
    </keep-alive>
    <div class="row close-blank">
      <div class="col">
        <a @click="goBackToApplication" href="javascript:"> <i class="fad fa-times"></i> Afsluiten</a>
      </div>
    </div>
  </div>
</template>

<script>
  import candidateInformation from '../components/candidate/candidateInformation'
  import candidateInformationAdditional from '../components/candidate/candidateInformationAdditional.vue'

  import {candidateCreate} from '../components/mixins/candidateCreate.js';
  import {swalModals} from '../components/mixins/swalModals.js';

  export default {
    mixins: [candidateCreate, swalModals],
    components: {
      candidateInformation,
      candidateInformationAdditional
    },
    data() {
      return {
        birth: null,
        blankModus: true
      }
    },
    methods: {
      goBackToApplication() {
        this.$swal({
          title: 'Registratie formulier afsluiten',
          text: 'Vul het wachtwoord in om af te sluiten.',
          input: 'password',
          type: 'info',
          showCancelButton: true,
          confirmButtonText: 'Afsluiten',
          cancelButtonText: 'Annuleren',
          reverseButtons: true
        }).then(result => {
          if (result.value === 'Motivate') {
            localStorage.setItem('preventMoving', 'false');
            this.$router.push('/');
          } else if (result.value === 'Strontbroek') {
            localStorage.setItem('preventMoving', 'false');
            this.$router.push({name: 'home', params: {music: 'play'}});
          } else if (!result.dismiss) {
            this.$toasted.global.failedRequest(
              {message: 'Het wachtwoord was onjuist!'}
            );
          }
        })
      }
    },
    created() {
      localStorage.setItem('preventMoving', 'true');
    }
  }

  history.pushState(null, document.title, location.href);
  window.addEventListener('popstate', function (event) {
    history.pushState(null, document.title, location.href);
  });
</script>

<style lang="scss">
  .blanco-page {
    padding: 30px;

    .m-portlet__head-tools,
    .btn-save-close,
    .btn-save-match {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
    }

    .close-blank {
      margin-top: -15px;
      padding-bottom: 15px;
    }
  }
</style>